<div class="template-editor-container">
  <div class="editor-layout">
    <div class="main-content">
      <div class="top-menu" #topMenu>
        <div class="menu-actions">
          @if (isActive('INDENT')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.INDENT' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button (click)="indentItem()" [disabled]="!canIndent()">
                <mat-icon>chevron_right</mat-icon>
              </button>
            </span>
          }
          @if (isActive('OUTDENT')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.OUTDENT' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button (click)="outdentItem()" [disabled]="!canOutdent()">
                <mat-icon>chevron_left</mat-icon>
              </button>
            </span>
          }
          @if (isActive('ADD_ITEM')) {
            <button mat-icon-button (click)="addNewItem()" [matTooltip]="'TEMPLATES.EDITOR.ADD_ITEM' | translate" [matTooltipShowDelay]="0">
              <mat-icon>add</mat-icon>
            </button>
          }
          @if (isActive('ADD_SUB_ITEM')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button (click)="addSubItem()" [disabled]="!selectedItemId">
                <mat-icon>subdirectory_arrow_right</mat-icon>
              </button>
            </span>
          }
          @if (isActive('REMOVE')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.REMOVE' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button class="remove-button" (click)="removeItem()" [disabled]="!selectedItemId">
                <mat-icon>delete</mat-icon>
              </button>
            </span>
          }
          @if (isActive('EXPAND_ALL') || isActive('COLLAPSE_ALL')) {
            @if (hasAnyExpandedItems) {
              <button mat-icon-button (click)="collapseAll()" [matTooltip]="'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate" [matTooltipShowDelay]="0">
                <mat-icon>unfold_less</mat-icon>
              </button>
            } @else {
              <button mat-icon-button (click)="expandAll()" [matTooltip]="'TEMPLATES.EDITOR.EXPAND_ALL' | translate" [matTooltipShowDelay]="0">
                <mat-icon>unfold_more</mat-icon>
              </button>
            }
          }
          @if (isActive('DUPLICATE')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.DUPLICATE' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button (click)="duplicateItem()" [disabled]="!selectedItemId">
                <mat-icon>content_copy</mat-icon>
              </button>
            </span>
          }
          @if (displayMenuButton) {
            <button mat-icon-button [matMenuTriggerFor]="overflowMenu" class="overflow-menu-button">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #overflowMenu="matMenu">
            @if (!isActive('INDENT')) {
              <button mat-menu-item (click)="indentItem()" [disabled]="!canIndent()">
                <mat-icon>chevron_right</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.INDENT' | translate }}</span>
              </button>
            }
            @if (!isActive('OUTDENT')) {
              <button mat-menu-item (click)="outdentItem()" [disabled]="!canOutdent()">
                <mat-icon>chevron_left</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.OUTDENT' | translate }}</span>
              </button>
            }
            @if (!isActive('ADD_ITEM')) {
              <button mat-menu-item (click)="addNewItem()">
                <mat-icon>add</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.ADD_ITEM' | translate }}</span>
              </button>
            }
            @if (!isActive('ADD_SUB_ITEM')) {
              <button mat-menu-item (click)="addSubItem()" [disabled]="!selectedItemId">
                <mat-icon>add</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.ADD_SUB_ITEM' | translate }}</span>
              </button>
            }
            @if (!isActive('REMOVE')) {
              <button mat-menu-item (click)="removeItem()" [disabled]="!selectedItemId">
                <mat-icon>delete</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.REMOVE' | translate }}</span>
              </button>
            }
            @if (!isActive('EXPAND_ALL') && !isActive('COLLAPSE_ALL')) {
              @if (hasAnyExpandedItems) {
                <button mat-menu-item (click)="collapseAll()">
                  <mat-icon>unfold_less</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.COLLAPSE_ALL' | translate }}</span>
                </button>
              } @else {
                <button mat-menu-item (click)="expandAll()">
                  <mat-icon>unfold_more</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.EXPAND_ALL' | translate }}</span>
                </button>
              }
            }
            @if (!isActive('DUPLICATE')) {
              <button mat-menu-item (click)="duplicateItem()" [disabled]="!selectedItemId">
                <mat-icon>content_copy</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.DUPLICATE' | translate }}</span>
              </button>
            }
            @if (!isActive('REVERT')) {
              <button mat-menu-item (click)="revertToLastSaved()" [disabled]="!hasUnsavedChanges">
                <mat-icon>undo</mat-icon>
                <span>{{ 'TEMPLATES.EDITOR.REVERT' | translate }}</span>
              </button>
            }
            @if (superModeEnabled && !isActive('FULLSCREEN')) {
              @if (isFullscreenModeEnabled) {
                <button mat-menu-item (click)="exitFullscreenRequested.emit()">
                  <mat-icon>arrow_back</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.BACK_TO_CALL' | translate }}</span>
                </button>
              } @else {
                <button mat-menu-item (click)="fullscreenRequested.emit()">
                  <mat-icon>fullscreen</mat-icon>
                  <span>{{ 'TEMPLATES.EDITOR.FULLSCREEN' | translate }}</span>
                </button>
              }
            }
          </mat-menu>
        </div>
        <div class="save-actions">
          @if (isActive('REVERT')) {
            <span [matTooltip]="'TEMPLATES.EDITOR.REVERT' | translate" [matTooltipShowDelay]="0">
              <button mat-icon-button (click)="revertToLastSaved()" [disabled]="!hasUnsavedChanges">
                <mat-icon>undo</mat-icon>
              </button>
            </span>
          }
          @if (superModeEnabled && isActive('FULLSCREEN')) {
            @if (isFullscreenModeEnabled) {
              <button
                mat-icon-button
                (click)="exitFullscreenRequested.emit()"
                [matTooltip]="'TEMPLATES.EDITOR.BACK_TO_CALL' | translate"
                [matTooltipShowDelay]="0"
              >
                <mat-icon>close_fullscreen</mat-icon>
              </button>
            } @else {
              <button mat-icon-button (click)="fullscreenRequested.emit()" [matTooltip]="'TEMPLATES.EDITOR.FULLSCREEN' | translate" [matTooltipShowDelay]="0">
                <mat-icon>fullscreen</mat-icon>
              </button>
            }
          }
          <button mat-flat-button color="primary" (click)="saveTemplate()" [disabled]="!hasUnsavedChanges">{{ 'TEMPLATES.EDITOR.SAVE' | translate }}</button>
        </div>
      </div>

      <div class="content-wrapper" (click)="deselectItem($event)">
        <div class="items-container" cdkDropList (cdkDropListDropped)="onItemDrop($event)">
          @for (item of flattenedItems; track item.id) {
            <app-template-item
              [item]="item"
              [availableResources]="availableResources"
              [allowFileUpload]="allowFileUpload"
              [selectedItemId]="selectedItemId"
              [attendeeNames]="attendeeNames"
              [superModeEnabled]="superModeEnabled"
              (itemSelected)="selectItem($event)"
              (contentChanged)="markAsChanged()"
              (fileUploadRequested)="fileUploadRequested.emit($event)"
              (pdfPreviewRequested)="openPdfPreview($event)"
            />
          }
        </div>
      </div>
    </div>
  </div>
</div>
